/* eslint-disable */
import { GetterTree } from "vuex";
import { Offer } from "@/models/offer";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { OfferState } from "@/types/offer";

const getters: GetterTree<OfferState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Offer();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((offer) => Offer.toSelectItem(offer))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((offer) => {
          return offer.id == id;
        })
      : new Offer();
  },
};

export default getters;
